import React, { useState } from 'react';
import './SearchBar.css';

function SearchBar(props) {
    const [input, setInput] = useState('');

    const handleChange = (event) => {
        event.preventDefault();
        setInput(event.target.value);
    }

    const handleSubmit = (event) => {
        //alert(input);
        event.preventDefault();
        props.onSearch(input);
        setInput('');
    }

    return (
        <>
            <form className="submit-form" onSubmit={handleSubmit}>
                <input 
                    id="search" 
                    name="name"
                    type="text"
                    value={input}
                    onChange={handleChange}
                    placeholder='Search for a song...'
                    required
                />
                <button type='submit'>Search</button>
            </form>
        </>
    );
}

export default SearchBar;